// extracted by mini-css-extract-plugin
export default {"document":"DocumentsList_document__uxWk2"};